import BasePage from '../../components/base-page/base-page';
import Share from '../../../shared/utils/share/share';
import CategoryTabs from '../../components/category-tabs/category-tabs';
import BlogSearch from '../../components/search/search';
import SideScrollingBanner from '../../components/side-scrolling-banner/side-scrolling-banner';

import './blog.scss';

class BlogPage extends BasePage {
  ui = {
    navContainer: '.js-blog-category-navigation',
  };

  uiCollections = {
    contentBannerButton: '.js-promo-banner-cta',
  }

  events = {
    'click @uiCollections.contentBannerButton': 'handleContentBannerButtonClick',
  }

  static activeSearchingClass = 'blog-category-navigation_active';

  onInit() {
    super.onInit();
    new SideScrollingBanner().init();
    new Share().init();
    new CategoryTabs().init();
    new BlogSearch({
      activeSearchHandler: this.activeSearchHandler,
      defaultSearchHandler: this.defaultSearchHandler,
    }).init();
  }

  handleContentBannerButtonClick = (e) => {
    e.preventDefault();
    this.signupModal.open();
  }

  activeSearchHandler = () => {
    this.ui.navContainer.classList.add(BlogPage.activeSearchingClass);
  };

  defaultSearchHandler = () => {
    this.ui.navContainer.classList.remove(BlogPage.activeSearchingClass);
  };
}

export default BlogPage;

BlogPage.initOnDomLoaded();
